// src/service/facilityService.js
import { MAIN_API } from "../../config/api";

const facilityService = {
  // Get all facilities
  getAllFacilities: async () => {
    try {
      const endpoint = `${MAIN_API}/vendor/facilities/all`;

      console.log('Fetching facilities from:', endpoint);

      const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
      console.log('Facilities response:', data);
      return data;
    } catch (error) {
      console.error('Error fetching facilities:', error);
      throw { success: false, message: error.message || 'Failed to fetch facilities. Please try again.' };
    }
  },

  // Get machines by facility ID
  getMachinesByFacility: async (facilityId) => {
    try {
      const endpoint = `${MAIN_API}/vendor/machines?facilityId=${facilityId}`;

      console.log('Fetching machines from:', endpoint);

      const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
      console.log('Machines response:', data);
      return data;
    } catch (error) {
      console.error('Error fetching machines:', error);
      throw { success: false, message: error.message || 'Failed to fetch machines. Please try again.' };
    }
  },



  // Get all available machines (no facility filter)
  getAvailableMachines: async () => {
    try {
      const endpoint = `${MAIN_API}/vendor/machines/available`;

      console.log('Fetching available machines from:', endpoint);

      const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
      console.log('Available machines response:', data);
      return data;
    } catch (error) {
      console.error('Error fetching available machines:', error);
      throw { success: false, message: error.message || 'Failed to fetch available machines. Please try again.' };
    }
  },


  // Get machine by ID
  getMachineById: async (machineId) => {
    try {
      const endpoint = `${MAIN_API}/vendor/machines/${machineId}`;

      console.log('Fetching machine from:', endpoint);

      const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
      console.log('Machine details response:', data);
      return data;
    } catch (error) {
      console.error('Error fetching machine details:', error);
      throw { success: false, message: error.message || 'Failed to fetch machine details. Please try again.' };
    }
  },


};

export default facilityService;